(() => {
  const instances = new WeakMap();

  const normalize = (value = '') => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();

  const initialize = (root = document) => {
    const sections = root.matches?.('[data-aqua-faq]') ? [root] : [...(root.querySelectorAll?.('[data-aqua-faq]') || [])];
    sections.forEach((section) => {
      if (instances.has(section)) return;

      const input = section.querySelector('[data-aqua-faq-search-input]');
      const clearButton = section.querySelector('[data-aqua-faq-clear]');
      const emptyClear = section.querySelector('[data-aqua-faq-empty-clear]');
      const empty = section.querySelector('[data-aqua-faq-empty]');
      const count = section.querySelector('[data-aqua-faq-count]');
      const filters = [...section.querySelectorAll('[data-aqua-faq-filter]')];
      const groups = [...section.querySelectorAll('[data-aqua-faq-group]')];
      const items = [...section.querySelectorAll('[data-aqua-faq-item]')];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const animations = new Map();
      const desired = new Map();
      const removers = [];
      let activeCategory = 'all';

      const parts = (details) => {
        const summary = details.querySelector(':scope > summary');
        const panel = summary?.getAttribute('aria-controls') ? document.getElementById(summary.getAttribute('aria-controls')) : null;
        return { summary, panel };
      };
      const clearPanelStyles = (panel) => ['height', 'overflow', 'opacity', 'transform'].forEach((property) => panel.style.removeProperty(property));
      const setImmediate = (details, open) => {
        animations.get(details)?.cancel();
        animations.delete(details);
        desired.set(details, open);
        const { summary, panel } = parts(details);
        details.open = open;
        summary?.setAttribute('aria-expanded', String(open));
        if (panel) clearPanelStyles(panel);
      };
      const toggle = (details, open) => {
        const { summary, panel } = parts(details);
        if (!summary || !panel || reducedMotion.matches || typeof panel.animate !== 'function') return setImmediate(details, open);

        const previous = animations.get(details);
        const startHeight = panel.getBoundingClientRect().height;
        const current = getComputedStyle(panel);
        const startOpacity = details.open ? current.opacity : '0';
        const startTransform = details.open && current.transform !== 'none' ? current.transform : (details.open ? 'translateY(0)' : 'translateY(3px)');
        previous?.cancel();
        desired.set(details, open);
        summary.setAttribute('aria-expanded', String(open));
        if (open) details.open = true;
        panel.style.height = `${startHeight}px`;
        panel.style.overflow = 'hidden';
        panel.style.opacity = startOpacity;
        panel.style.transform = startTransform;
        const endHeight = open ? panel.scrollHeight : 0;
        const animation = panel.animate([
          { height: `${startHeight}px`, opacity: startOpacity, transform: startTransform },
          { height: `${endHeight}px`, opacity: open ? 1 : 0, transform: open ? 'translateY(0)' : 'translateY(-3px)' }
        ], { duration: 360, easing: 'ease-in-out', fill: 'forwards' });
        animations.set(details, animation);
        animation.finished.then(() => {
          if (animations.get(details) !== animation) return;
          animations.delete(details);
          if (!open) details.open = false;
          animation.cancel();
          clearPanelStyles(panel);
        }).catch(() => {});
      };

      const update = () => {
        const query = normalize(input?.value);
        let visibleCount = 0;
        items.forEach((item) => {
          const categoryMatches = activeCategory === 'all' || item.dataset.aquaFaqCategory === activeCategory;
          const searchMatches = !query || normalize(item.dataset.aquaFaqSearch).includes(query);
          const visible = categoryMatches && searchMatches;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
          else if (item.open || desired.get(item)) setImmediate(item, false);
        });
        groups.forEach((group) => { group.hidden = !group.querySelector('[data-aqua-faq-item]:not([hidden])'); });
        if (count) count.textContent = String(visibleCount);
        if (empty) empty.hidden = visibleCount !== 0;
        if (clearButton) clearButton.hidden = !query;
      };
      const clearSearch = () => {
        if (input) input.value = '';
        activeCategory = 'all';
        filters.forEach((filter) => {
          const active = filter.dataset.aquaFaqFilter === 'all';
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', String(active));
        });
        update();
        input?.focus();
      };

      items.forEach((details) => {
        const { summary } = parts(details);
        if (!summary) return;
        desired.set(details, details.open);
        summary.setAttribute('aria-expanded', String(details.open));
        const handleClick = (event) => {
          event.preventDefault();
          toggle(details, !(desired.get(details) ?? details.open));
        };
        summary.addEventListener('click', handleClick);
        removers.push(() => summary.removeEventListener('click', handleClick));
      });

      const availableCategories = new Set(groups.map((group) => group.dataset.aquaFaqGroup));
      filters.forEach((filter) => {
        const category = filter.dataset.aquaFaqFilter;
        if (category !== 'all' && !availableCategories.has(category)) filter.hidden = true;
          const handleClick = () => {
            activeCategory = category;
            filters.forEach((candidate) => {
            const active = candidate === filter;
            candidate.classList.toggle('is-active', active);
              candidate.setAttribute('aria-pressed', String(active));
            });
            update();
          section.querySelector('.aqua-faq__content-heading')?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        };
        filter.addEventListener('click', handleClick);
        removers.push(() => filter.removeEventListener('click', handleClick));
      });
      const handleInput = () => update();
      input?.addEventListener('input', handleInput);
      clearButton?.addEventListener('click', clearSearch);
      emptyClear?.addEventListener('click', clearSearch);
      removers.push(() => input?.removeEventListener('input', handleInput), () => clearButton?.removeEventListener('click', clearSearch), () => emptyClear?.removeEventListener('click', clearSearch));
      update();

      instances.set(section, () => {
        removers.forEach((remove) => remove());
        animations.forEach((animation, details) => { animation.cancel(); const { panel } = parts(details); if (panel) clearPanelStyles(panel); });
        animations.clear();
        instances.delete(section);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.('[data-aqua-faq]') ? event.target : event.target.querySelector?.('[data-aqua-faq]');
    if (section) instances.get(section)?.();
  });
})();
